import React from "react";
import SideMenu from "./SideMenu";
import { buildSuperAdminMenuItems } from "./menuItems";

const SuperAdminSideMenu = () => {
  return <SideMenu sideMenuItems={buildSuperAdminMenuItems("/admin")} />;
};

export default SuperAdminSideMenu;
